export const formatName = (name: string) => {
  return name
    .trim()
    .replace(/[\/]/g, "-")
    .replace(/[–—]/g, "-")
    .replace(/\s+/g, "-")
    .replace(/[^a-zA-Z0-9-]/g, "")
    .toLowerCase()
    .replace(/-+/g, "-");
};
